export default "__VITE_ASSET__oHj2Ub$u__"